import {NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'
import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {AuthInterceptor} from './core/interceptors'
import {AppSideNavComponent, LoginComponent} from "./components"
import {TopNavComponent} from "./core/components/top-nav/top-nav.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ToastrModule} from "ngx-toastr";
import {DotAnimationComponent} from "./core/components/loading/dot-animation/dot-animation.component";
import {NotificationAlertComponent} from "./core/components/notification/notification-alert.component";
import {TruncatePipe} from "./core/pipes/truncate.pipe";

@NgModule({ declarations: [
        AppComponent,


    ],
    bootstrap: [AppComponent],
    exports: [
        NotificationAlertComponent,
    ], imports: [BrowserModule,
        AppRoutingModule,
        AppSideNavComponent,
        TopNavComponent,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        LoginComponent,
        // FontAwesomeModule,
        NotificationAlertComponent,
        NotificationAlertComponent, DotAnimationComponent, TruncatePipe], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
